import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  height?: number;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  placeholder = 'Markdown eingeben...',
  disabled = false,
  height = 300
}) => {
  return (
    <div className="markdown-editor" data-color-mode="auto">
      <MDEditor
        value={value}
        onChange={onChange}
        preview="edit"
        height={height}
        visibleDragbar={false}
        textareaProps={{
          placeholder,
          disabled,
          style: {
            fontSize: 14,
            lineHeight: 1.5,
            fontFamily: 'inherit'
          }
        }}
      />
    </div>
  );
};

export default MarkdownEditor;